import $axios from "@/plugins/axios"

export default class DocumentApi {
  async getManualDocument() {
    return await $axios.get("/manual-page/download")
  }
}
